import { scheduledReportTypeTranslationMap } from 'dashboard/constants/scheduled-report-type-translation-map.constant';
import { ScheduledReportType } from 'dashboard/enums/scheduled-report-type.enum';

export const scheduledReportTypeOptions = [
    {
        label: scheduledReportTypeTranslationMap[ScheduledReportType.LISTINGS_REPORT],
        value: ScheduledReportType.LISTINGS_REPORT,
    },
    {
        label: scheduledReportTypeTranslationMap[ScheduledReportType.DISTRIBUTION_TRACKING_REPORT],
        value: ScheduledReportType.DISTRIBUTION_TRACKING_REPORT,
    },
    {
        label: scheduledReportTypeTranslationMap[ScheduledReportType.PREMIER_INN_REPORT],
        value: ScheduledReportType.PREMIER_INN_REPORT,
    },
];
